import ReportWrapper from '../ReportWrapper'
import React from 'react'
import ExceptionListOverview from './ExceptionListOverview'
import BankOutOfConnectionFraud from './BankOutOfConnectionFraud'
import OnlineLendingOutOfConnectionFraud from './OnlineLendingOutOfConnectionFraud'
import ReportSectionHeading from '../ReportSectionHeading'

interface ExceptionListProps {
  data: any
  title: string
  sectionIndex?: string
}

export default function ExceptionList({ data, title, sectionIndex }: ExceptionListProps) {
  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <ExceptionListOverview data={data} />
      <BankOutOfConnectionFraud data={data} />
      <OnlineLendingOutOfConnectionFraud data={data} />
    </ReportWrapper>
  )
}
